import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTelegram } from './hooks/useTelegram';
import { useAuthStore } from './store/auth';
import { Layout } from './components/Layout';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProtocolsPage } from './pages/ProtocolsPage';
import { ProtocolPage } from './pages/ProtocolPage';
import { TaskPage } from './pages/TaskPage';
import { CreateTaskPage } from './pages/CreateTaskPage';
import { KpiPage } from './pages/KpiPage';
import { SettingsPage } from './pages/SettingsPage';
import { SystemAdminsPage } from './pages/SystemAdminsPage';
import { MyTasksPage } from './pages/MyTasksPage';
import { CreatePage } from './pages/CreatePage';
import { StatsPage } from './pages/StatsPage';
import { ChecklistsPage } from './pages/ChecklistsPage';
import { ChecklistPlanPage } from './pages/ChecklistPlanPage';
import { ChecklistApprovalsPage } from './pages/ChecklistApprovalsPage';
import { ChecklistCalendarPage } from './pages/ChecklistCalendarPage';
import { ChecklistKpiPage } from './pages/ChecklistKpiPage';
import { CreateChecklistPage } from './pages/CreateChecklistPage';
import { EditChecklistPage } from './pages/EditChecklistPage';
import { AssignChecklistPage } from './pages/AssignChecklistPage';
// import { LoadingScreen } from './components/LoadingScreen'; // Не используется

function App() {
  const { webApp, user, isReady } = useTelegram();
  const { setUser, setInitData } = useAuthStore();

  // Убрано лишнее логирование

  useEffect(() => {
    if (isReady && webApp) {
      // Настраиваем Telegram WebApp
      webApp.ready();
      webApp.expand();
      
      // Проверяем версию перед вызовом методов, которые не поддерживаются в версии 6.0
      const version = parseFloat(webApp.version || '0');
      
      if (version >= 6.1) {
        // Устанавливаем цвета (только в версии 6.1+)
        try {
          webApp.setHeaderColor?.('secondary_bg_color');
          webApp.setBackgroundColor?.('bg_color');
        } catch (e) {
          // Игнорируем ошибки
        }
        
        // Включаем кнопку закрытия (только в версии 6.1+)
        try {
          webApp.enableClosingConfirmation?.();
        } catch (e) {
          // Игнорируем ошибки
        }
      }

      // Сохраняем данные авторизации
      if (user) {
        setUser({
          id: user.id.toString(),
          telegramId: user.id.toString(),
          firstName: user.firstName,
          lastName: user.lastName || null,
          username: user.username || null,
          photoUrl: user.photoUrl || null,
        });
      }

      if (webApp.initData) {
        setInitData(webApp.initData);
      }
    }
  }, [isReady, webApp, user, setUser, setInitData]);

  useEffect(() => {
    if (!webApp?.initData) return;
    setInitData(webApp.initData);
  }, [webApp?.initData, setInitData]);

  // УБРАНА БЛОКИРОВКА - приложение запускается сразу
  // if (!isReady) {
  //   return <LoadingScreen />;
  // }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/projects" replace />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/protocols" element={<ProtocolsPage />} />
        <Route path="/projects/:projectId/protocols" element={<ProtocolsPage />} />
        <Route path="/protocols/:protocolId" element={<ProtocolPage />} />
        <Route path="/protocols/:protocolId/tasks/new" element={<CreateTaskPage />} />
        <Route path="/tasks/:taskId" element={<TaskPage />} />
        <Route path="/projects/:projectId/kpi" element={<KpiPage />} />
        <Route path="/projects/:projectId/settings" element={<SettingsPage />} />
        <Route path="/system-admins" element={<SystemAdminsPage />} />
        {/* Новые страницы для нижней навигации */}
        <Route path="/my-tasks" element={<MyTasksPage />} />
        <Route path="/checklists" element={<ChecklistsPage />} />
        <Route path="/checklists/plan" element={<ChecklistPlanPage />} />
        <Route path="/checklists/approvals" element={<ChecklistApprovalsPage />} />
        <Route path="/checklists/kpi" element={<ChecklistKpiPage />} />
        <Route path="/checklists/calendar" element={<ChecklistCalendarPage />} />
        <Route path="/checklists/new" element={<CreateChecklistPage />} />
        <Route path="/checklists/:templateId/edit" element={<EditChecklistPage />} />
        <Route path="/projects/:projectId/checklists/new" element={<CreateChecklistPage />} />
        <Route path="/checklists/assign" element={<AssignChecklistPage />} />
        <Route path="/checklists/assign/:templateId" element={<AssignChecklistPage />} />
        <Route path="/projects/:projectId/checklists/assign" element={<AssignChecklistPage />} />
        <Route path="/projects/:projectId/checklists/assign/:templateId" element={<AssignChecklistPage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/stats" element={<StatsPage />} />
      </Routes>
    </Layout>
  );
}

export default App;

